var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-category__wrapper", attrs: { id: "content" } },
    [
      _c(
        "div",
        {
          staticClass: "l-category__filter",
          class: { open: _vm.isFiltersVisible }
        },
        [
          _c("div", { staticClass: "l-category__search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm"
                }
              ],
              attrs: {
                placeholder: _vm.translations["What are you looking for?"]
              },
              domProps: { value: _vm.searchTerm },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.search()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchTerm = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "button",
                on: {
                  click: function($event) {
                    return _vm.search()
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "28",
                      height: "27",
                      viewBox: "0 0 28 27",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11.981 22.6005C9.78254 22.6007 7.63339 21.949 5.80531 20.7278C3.97723 19.5067 2.5523 17.7708 1.71072 15.7398C0.869132 13.7088 0.648681 11.4739 1.07724 9.31763C1.5058 7.16135 2.56411 5.18057 4.11838 3.62575C5.67264 2.07093 7.65303 1.0119 9.80916 0.582565C11.9653 0.153232 14.2003 0.372879 16.2316 1.21373C18.2629 2.05459 19.9992 3.47889 21.2211 5.30653C22.4429 7.13417 23.0954 9.28308 23.096 11.4815C23.0964 12.9415 22.8092 14.3872 22.2508 15.7361C21.6924 17.0851 20.8737 18.3108 19.8416 19.3433C18.8095 20.3758 17.584 21.1949 16.2353 21.7538C14.8865 22.3127 13.4409 22.6004 11.981 22.6005V22.6005ZM11.981 1.98254C10.1021 1.98254 8.26534 2.5397 6.70307 3.58357C5.1408 4.62745 3.92316 6.11115 3.20413 7.84704C2.4851 9.58294 2.29697 11.4931 2.66353 13.3359C3.03009 15.1787 3.93487 16.8715 5.26347 18.2001C6.59207 19.5286 8.28481 20.4334 10.1276 20.8C11.9704 21.1666 13.8806 20.9784 15.6165 20.2594C17.3524 19.5404 18.8361 18.3227 19.8799 16.7605C20.9238 15.1982 21.481 13.3615 21.481 11.4825C21.481 8.96298 20.4801 6.54662 18.6985 4.76502C16.9169 2.98342 14.5005 1.98254 11.981 1.98254V1.98254Z",
                        fill: "#919191"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M26.496 26.8075C26.3901 26.8079 26.2852 26.7872 26.1873 26.7467C26.0895 26.7062 26.0007 26.6466 25.926 26.5715L18.771 19.4165C18.6934 19.3422 18.6314 19.2532 18.5886 19.1546C18.5459 19.056 18.5233 18.9498 18.5221 18.8424C18.5209 18.7349 18.5413 18.6284 18.5818 18.5289C18.6224 18.4294 18.6825 18.339 18.7584 18.263C18.8344 18.187 18.9248 18.127 19.0243 18.0864C19.1238 18.0458 19.2304 18.0255 19.3378 18.0267C19.4453 18.0278 19.5514 18.0505 19.65 18.0932C19.7486 18.1359 19.8377 18.1979 19.912 18.2755L27.067 25.4305C27.1796 25.5434 27.2562 25.6871 27.2873 25.8434C27.3183 25.9998 27.3023 26.1619 27.2414 26.3092C27.1804 26.4565 27.0772 26.5824 26.9447 26.6711C26.8122 26.7598 26.6564 26.8073 26.497 26.8075H26.496Z",
                        fill: "#919191"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            !_vm.isFiltersVisible
              ? _c(
                  "div",
                  {
                    staticClass: "toggle",
                    on: {
                      click: function($event) {
                        return _vm.showFilters()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translations["More filtering options"]) +
                        "\n        "
                    ),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "7",
                          viewBox: "0 0 10 7",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z",
                            fill: "white"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFiltersVisible
              ? _c(
                  "div",
                  {
                    staticClass: "toggle",
                    on: {
                      click: function($event) {
                        return _vm.hideFilters()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translations["Less filtering options"]) +
                        "\n        "
                    ),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "7",
                          viewBox: "0 0 10 7",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z",
                            fill: "white"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.isFiltersVisible
              ? _c("div", { staticClass: "l-category__filters" }, [
                  _c(
                    "div",
                    { staticClass: "l-category__filter-dropdowns" },
                    _vm._l(_vm.filterOptions, function(option) {
                      return _c("multiselect", {
                        key: option.id,
                        attrs: {
                          options: option.options,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": false,
                          "preserve-search": true,
                          placeholder: option.label,
                          label: "label",
                          "track-by": "label",
                          "preselect-first": false,
                          taggable: false,
                          mode: "multiple"
                        },
                        on: {
                          close: function($event) {
                            return _vm.toggleFilter("close")
                          },
                          open: function($event) {
                            return _vm.toggleFilter("open")
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function(ref) {
                                var values = ref.values
                                var search = ref.search
                                var isOpen = ref.isOpen
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: values.length && !isOpen,
                                          expression: "values.length && !isOpen"
                                        }
                                      ],
                                      staticClass: "multiselect__single"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option.label) +
                                          " (" +
                                          _vm._s(values.length) +
                                          ")\n              "
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "option",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "option__wrapper" },
                                    [
                                      _c("span", {
                                        staticClass: "option__box"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option__label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.label) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.filters[option.handle],
                          callback: function($$v) {
                            _vm.$set(_vm.filters, option.handle, $$v)
                          },
                          expression: "filters[option.handle]"
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "l-category__filtersaction" }, [
                    _c(
                      "div",
                      {
                        staticClass: "reset",
                        on: {
                          click: function($event) {
                            return _vm.reset()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.translations["Reset filtering"]) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "l-category__filtersaction--mobile" }, [
            !_vm.isFiltersVisible
              ? _c(
                  "div",
                  {
                    staticClass: "toggle",
                    on: {
                      click: function($event) {
                        return _vm.showFilters()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translations["More filtering options"]) +
                        "\n        "
                    ),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "7",
                          viewBox: "0 0 10 7",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z",
                            fill: "white"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFiltersVisible
              ? _c(
                  "div",
                  {
                    staticClass: "toggle",
                    on: {
                      click: function($event) {
                        return _vm.hideFilters()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translations["Less filtering options"]) +
                        "\n        "
                    ),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "7",
                          viewBox: "0 0 10 7",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M1.086 0.827995L0.171997 1.74199L4.743 6.314L9.314 1.74299L8.4 0.828995L4.743 4.48499L1.086 0.827995Z",
                            fill: "white"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "l-category__grid-tools" }, [
        _c("div", [
          _vm._v("\n      " + _vm._s(_vm.translations["Showing"]) + " "),
          _c("span", [_vm._v(_vm._s(_vm.totalLoaded))]),
          _vm._v("\n      " + _vm._s(_vm.translations["products"]) + "\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sorting", class: "sorting--" + _vm.sortDirection },
          [
            _c(
              "div",
              {
                staticClass: "direction",
                on: {
                  click: function($event) {
                    return _vm.toggleDirection()
                  }
                }
              },
              [_c("img", { attrs: { src: "/images/sort.svg" } })]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "type" },
              [
                _c("multiselect", {
                  attrs: {
                    "deselect-label": "Can't remove this value",
                    "track-by": "code",
                    label: "label",
                    placeholder: "Sort by...",
                    options: _vm.sortOptions,
                    searchable: false,
                    "clear-on-select": false,
                    taggable: false,
                    "show-labels": false
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "singleLabel",
                      fn: function(props) {
                        return [
                          _c("span", { staticClass: "option__desc" }, [
                            _c("span", { staticClass: "option__title" }, [
                              _vm._v(_vm._s(props.option.label))
                            ])
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedSortOption,
                    callback: function($$v) {
                      _vm.selectedSortOption = $$v
                    },
                    expression: "selectedSortOption"
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "l-category__grid", attrs: { id: "grid" } },
        [_vm._t("products")],
        2
      ),
      _vm._v(" "),
      _vm.showLoadMore
        ? _c(
            "div",
            {
              staticClass:
                "l-category__row l-category__loadmore c-categoryGrid__loadMore"
            },
            [
              _c(
                "div",
                {
                  staticClass: "o-btn",
                  class: { loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.loadNextPage()
                    }
                  }
                },
                [_c("inline-loader")],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "l-category__row" }, [
        _c("div", { staticClass: "l-category__counter" }, [
          _vm._v("\n      " + _vm._s(_vm.translations["Showing"]) + " "),
          _c("span", [_vm._v(_vm._s(_vm.totalLoaded))]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.translations["of"]) +
              " " +
              _vm._s(_vm.totalProducts) +
              "\n      " +
              _vm._s(_vm.translations["products"]) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showLoader
          ? _c(
              "div",
              { staticClass: "c-categoryGrid__loader" },
              [_vm._t("loader")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }